/** FastAPI の `detail` を取り出す。axios の message は「status code 502」としか言わないため */

import { isAxiosError } from 'axios'

export const apiErrorMessage = (error: unknown, fallback: string): string => {
  if (isAxiosError(error)) {
    const detail: unknown = error.response?.data?.detail
    if (typeof detail === 'string' && detail) return detail
  }
  if (error instanceof Error && error.message) return error.message
  return fallback
}
